var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',[_c('HeaderTop',{attrs:{"breakdowns":_vm.breakdowns}}),_vm._v(" "),_c('HeaderNav',{attrs:{"breakdowns":_vm.breakdowns}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }